import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import Loader from 'react-loader';
import { toast } from 'react-toastify';
import InstallationDocumentListItem from './InstallationDocumentListItem';
import './ServiceTable.css';
import '../../Main.css';
import {
  BASE_URL,
  createImageFromBase64, createRequestProperties,
  installationDocumentImagesRequestApi,
} from '../../actions/helper';
import { getLocalizedName } from '../../localization/LocalizedString';

class InstallationDocumentTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      imageData: null,
      isModalLoading: true,
      isLoadingPDFPreview: false,
    };
  }

  columnsCount = () => 13;

  showModal = (document) => {
    this.fetchImages(document.id);
    this.setState({
      modalOpen: true,
    });
  };

  fetchImages = (id) => {
    installationDocumentImagesRequestApi(`/installationdocument/images/${id}`)
      .then((imageData) => {
        if (imageData != null) {
          this.setState({
            imageData,
          });
        } else {
          this.setState({ isModalLoading: false });
        }
      });
  };

  closeModal = () => {
    this.setState({
      imageData: null,
      modalOpen: false,
      isModalLoading: true,
    });
  };

  renderHeader = () => {
    const { translate } = this.props;

    return (
      <thead>
        <tr className="report-table-header_service">
          <th className="report-table-th_service">{translate('service_report.column_task.user')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.employeeId')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.date')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.customer')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.consignorName')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.terminal')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.end_customer')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.address')}</th>
          <th className="report-table-th_service">{translate('service_report.column_issue.city')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.deviceName')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.shipmentId')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.duration')}</th>
          <th className="report-table-th_service">{translate('service_report.column_task.pdf')}</th>
        </tr>
      </thead>
    );
  };

  renderModal = () => {
    const { translate, currentLanguage } = this.props;
    const { imageData, isModalLoading, modalOpen: open } = this.state;

    const modalStyles = {
      modal: {
        minWidth: '400px',
        minHeight: '400px',
        padding: '2rem',
        maxHeight: '90vh',
        overflowY: 'auto',
      },
    };

    const imageStyles = {
      paddingBottom: '10px',
      objectFit: 'contain',
      maxHeight: '600px',
      width: '100%',
      height: '100%',
    };

    const options = {
      lines: 13,
      length: 14,
      width: 7,
      radius: 21,
      scale: 1.00,
      corners: 1,
      color: '#000',
      opacity: 0.25,
      rotate: 0,
      direction: 1,
      speed: 1,
      trail: 60,
      fps: 20,
      position: 'relative',
    };

    return (
      <div>
        <Modal open={open} onClose={this.closeModal} little showCloseIcon styles={modalStyles}>
          <div className="issue-item">
            <div className="installation-document-image-div">
              {(Array.isArray(imageData) && imageData.length !== 0) ? imageData.map((item) => (
                <div>
                  <h3>{getLocalizedName(item, currentLanguage)}</h3>
                  {item.imageList.length === 0 ? (translate('new_task.no_device_image')) : (
                    item.imageList.map((image) => (
                      <img alt=""
                           src={createImageFromBase64(image)}
                           style={imageStyles} />
                    )))}
                </div>
              ))
                : (
                  <div>
                    {isModalLoading
                      ? (
                        <div className="installation-document-loader">
                          <Loader loaded={false} options={options} />
                        </div>
                      )
                      : (
                        <h4
                      className="primary-color">
                          {translate('new_task.no_data_found')}
                        </h4>
                      )}
                  </div>
                )}
            </div>
          </div>
        </Modal>
      </div>

    );
  };

  renderModalButton = (id, shippmetIds) => {
    const shippmetIdsString = shippmetIds.map((ids) => <div>{ids}</div>);
    return (
      <button className="button-without-style text-align-left" onClick={() => { this.showModal({ id }); }}>{ shippmetIdsString }</button>
    );
  }

  renderLoadingInfo = () => {
    const { translate, isLoading } = this.props;
    return isLoading
      ? (
        <React.Fragment>
          <tr className="report-table-row_service">
            <td colSpan={this.columnsCount()}
                className="report-table-cell_service_no_border">
              {translate('service_report.search.loading')}
            </td>
          </tr>
        </React.Fragment>
      )
      : null;
  };

  reasonModalHandler = (deviceData) => {
    this.setState({ showModal: true, deviceReason: deviceData.msg, deviceName: deviceData.deviceName });
  };

  renderResult = () => {
    const {
      translate, data, isLoading, currentLanguage,
    } = this.props;
    const { isLoadingPDFPreview } = this.state;
    if (isLoading) {
      return null;
    }

    const viewData = data.length > 0
      ? data.slice()
      : [];

    return (
      <React.Fragment>
        {viewData.length === 0 && (
          <tr>
            <td colSpan={this.columnsCount()}>
              {translate('service_report.search.no_data_found')}
            </td>
          </tr>
        )}

        {viewData.map((task) => (
          <InstallationDocumentListItem key={task.id}
                                        item={task}
                                        reasonModalHandler={this.reasonModalHandler}
                                        isLoadingPDFPreview={isLoadingPDFPreview}
                                        previewButtonHandler={this.servicePdfPreviewer}
                                        currentLanguage={currentLanguage}
                                        modalButton={this.renderModalButton(task.id, task.device.shipmentIds)} />
        ))}
      </React.Fragment>
    );
  };

  closePDFPreviewModalBox = () => {
    this.setState({
      imageData: null,
      pdfPreviewModalOpen: false,
      isModalLoading: true,
    });
  }

  servicePdfPreviewer = (pdfPreviewData) => {
    const { pdfPreviewModalOpen } = this.state;
    if (pdfPreviewData !== undefined) {
      const fileID = pdfPreviewData.shipmentId;
      const pdfUrlBackend = '/installationdocument/report/pdf';
      this.setState({ isLoadingPDFPreview: true });
      fetch(`${BASE_URL}${pdfUrlBackend}/${fileID}`, createRequestProperties(null))
        .then((response) => {
          response.blob().then((blob) => {
            this.setState({ pdfPreviewModalOpen: true, isModalLoading: false });
            const url = window.URL.createObjectURL(blob);
            const pdfPreviewBox = document.getElementById('service-pdf-preview');
            if (url !== null) {
              pdfPreviewBox.src = url;
              this.setState({ isLoadingPDFPreview: false });
            }
          });
        })
        .catch((err) => toast.error(err.message));
    }

    const modalStyles = {
      modal: {
        minWidth: '1350px',
        minHeight: '950px',
        overflowY: 'auto',
      },
    };

    return (
      <div style={{ overflow: 'hidden' }}>
        <Modal open={pdfPreviewModalOpen} styles={modalStyles} onClose={this.closePDFPreviewModalBox}>
          <iframe src="" height="880px" width="1300px" title="PDF PREVIEW" id="service-pdf-preview" style={{ position: 'relative', top: '25px' }} />
        </Modal>
      </div>
    );
  }

  render() {
    const { showModal, deviceReason, deviceName } = this.state;
    const { translate } = this.props;
    const modalStyles = {
      modal: {
        top: '400px',
        minWidth: '500px',
        minHeight: '400px',
        padding: '2rem',
        maxHeight: '90vh',
        overflowY: 'auto',
      },
    };
    return (
      <div>
        <table className="report-table_service">
          {this.renderHeader()}
          {this.servicePdfPreviewer()}
          <tbody>
            {this.renderLoadingInfo()}
            {this.renderResult()}
            {this.renderModal()}
          </tbody>
        </table>
        <Modal open={showModal} styles={modalStyles} onClose={() => this.setState({ showModal: false })}>
          <div>
            <h3>
              {' '}
              { deviceName }
              {' '}
            </h3>
            <div>
              <br />
              <h4>
                {translate('work_list.column_task.device-not-installed-reason')}
                {' '}
                :
              </h4>
              <div>
                { deviceReason }
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
  translate: getTranslate(state.locale),
  session: state.session,
});

export default connect(
  mapStateToProps,
  null,
)(InstallationDocumentTable);



// WEBPACK FOOTER //
// ./src/components/servicereport/InstallationDocumentTable.js